<template>
  <div
    v-if="props.isOpenList"
    class="settings-item__list"
  >
    <Chip
      v-for="btn in getImportanceList"
      :key="btn.name"
      :use-cross-icon="false"
      :color="btn.colorName"
      class="settings-item__list-item"
      :model-value="isImportanceSelected(btn.importance)"
      @click.prevent="toggleImportance(btn.importance)"
    >
      {{ t('settings_item.importance.' + btn.name) }}
    </Chip>
  </div>
</template>
<script setup>
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import {computed, defineProps} from "vue";
import { t } from "@/controllerLK/GlobusLocalization";
import {debounce} from "@/functions/debouncer";
import {importanceList} from "@/const/importance.list";

const props = defineProps({
  isOpenList: {
    type: Boolean,
    default: false,
  }
});

const newsFeedStore = useNewsFeedStore();

// Список значимости без неопределенной.
const getImportanceList = computed(() => {
  return Object.values(importanceList).toReversed().filter((item) => item.importance !== null && item.importance !== 0);
});

// Вычисляемая функция. Проверка активна ли выбранная важность
const isImportanceSelected = computed(() => {
  return (importance) => {
    return !!newsFeedStore.filterImportance.list.find(item => item === importance);
  };
});

// Функция. Добавление критичности в фасет.
const toggleImportance = async (imp) => {
  if (isImportanceSelected.value(imp)) {
    newsFeedStore.filterImportance.list = newsFeedStore.filterImportance.list.filter(item => item !== imp);
  } else {
    newsFeedStore.filterImportance.list.push(imp);
  }
  await updateNewsDebounce();
};

// Функция. Обновление списка новостей
const updateNews = async () => {
  newsFeedStore.clearNewsFeed();
  await newsFeedStore.getNews();
};
const updateNewsDebounce = debounce(updateNews, 700);
</script>

<style lang="scss" scoped>
.settings-item {
  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;

    &-item { cursor: pointer; }
  }
}
</style>